//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'SIRS',
  data() {
    return {
      form:{
        temp:'0',
        hr:'0',
        resp:'0',
        wbc:'0'
      },
      hasScore:false,
      disabled:false,
      defaultJson:{
        "wbcHint": "WBC > 12  x 10⁹\/L 或\nWBC < 4 x 10⁹\/L 或\n杆状核 > 10%",
        "Heart Rate": "心率",
        "Respiration": "呼吸",
        "respHint": "呼吸频率 > 20 bpm 或\nPaCO₂ < 32 mmHg（4.3 kPa）",
        "tempHint": "T > 38°C 或\nT < 36°C",
        "{{ count }} out of 4 SIRS criteria met": "符合 {{ count }} 条 SIRS 诊断标准（共 4 条）",
        "heartHint": "心率 > 90 bpm",
        "No SIRS": "无 SIRS",
        "SIRS is diagnosed": "SIRS 诊断成立",
        "Temperature": "体温",
        "White Blood Cell Count": "白细胞计数"
      },
      major:0,
      minor:0
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.temp + form.hr + form.wbc + form.resp
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/SIRS.vue